import { SearchQueryParam, SearchQueryValues } from '../useSearchQuery/types';

export type ValidationError = {
  originCode: string;
  departureDate: string;
  returnDate: string;
  travellers: string;
};

export const EMPTY_FIELD_ERROR = 'EMPTY_FIELD_ERROR';

const TRAVEL_DATES_ERROR = 'Please select travel dates';
const TRAVELLERS_ERROR = 'Please select at least one traveller';

export const validate = (data: SearchQueryValues): ValidationError => {
  const isFieldEmpty = (key: SearchQueryParam) => !data?.[key];
  return {
    originCode: isFieldEmpty('originCode') ? EMPTY_FIELD_ERROR : '',
    departureDate: isFieldEmpty('departureDate') ? TRAVEL_DATES_ERROR : '',
    returnDate: isFieldEmpty('returnDate') ? TRAVEL_DATES_ERROR : '',
    travellers:
      isFieldEmpty('adults') &&
      isFieldEmpty('children') &&
      isFieldEmpty('infants')
        ? TRAVELLERS_ERROR
        : '',
  };
};
